<div class="email-verification">
  <div class="logo-header">
    <mat-icon class="logo" svgIcon="customer-logo"></mat-icon>
    <b>{{ platformName }}</b>
  </div>
  <h1>Email Verification</h1>
  <p>{{ messageText }}</p>
</div>
